export default import.meta.ROLLUP_FILE_URL_Dtt$I_fhwRWvzl6ncXD9iw